import Vuex from "vuex";
import Vue from "vue";
import setting from "./setting";
import project from "./project";
if (!window.Vuex) {
  Vue.use(Vuex);
}

export default new Vuex.Store({
  modules: {
    setting,
    project,
  },
  strict: true,
});
